import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex px-4" }
const _hoisted_2 = { class: "table-col col-date p-1" }
const _hoisted_3 = { class: "table-col col-amount p-1" }
const _hoisted_4 = { class: "table-col col-status p-1" }
const _hoisted_5 = { class: "table-col col-action p-1" }

import { computed } from 'vue'
import { StripeUpcomingInvoice } from '../../../api/v2/models/subscription'
import DialogDeleteSubscriptionConfirm from '../atoms_molecules/DialogDeleteSubscriptionConfirm.vue'
import { format } from 'date-fns'


export default /*@__PURE__*/_defineComponent({
  __name: 'StripeUpcomingInvoice',
  props: {
    stripeUpcomingInvoice: {},
    hideCancel: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ["cancel"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const date = computed(() => {
  return format(props.stripeUpcomingInvoice.periodEnd, 'YYYY/MM/DD')
})

const cancelSubscription = (message = '') => {
  emit('cancel', message)
}

const calculateAmountDue = () => {
  let amountDue = props.stripeUpcomingInvoice.amountDue
  const lines = props.stripeUpcomingInvoice.lines
  const totalCount = lines.data.length
  let membershipFee = 0
  if (totalCount > 1) {
    membershipFee = lines.data.find(line => line.description?.includes('Membership Fee'))?.amount || 0
  }

  if (membershipFee > 0) {
    return amountDue - membershipFee
  }
  return amountDue
}

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(date.value), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, _toDisplayString(calculateAmountDue().toLocaleString()) + "円", 1 /* TEXT */),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_v_chip, {
        class: "me-2 text-white",
        color: "blue",
        size: "small",
        label: ""
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" 支払い待ち ", -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      (!__props.hideCancel)
        ? (_openBlock(), _createBlock(DialogDeleteSubscriptionConfirm, {
            key: 0,
            title: "本当にサブスクリプションを削除しますか？",
            loading: __props.loading,
            onConfirmed: cancelSubscription
          }, null, 8 /* PROPS */, ["loading"]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

})